import React, { useEffect, useState } from "react";
import { Link, Outlet, matchPath, useLocation, useSearchParams } from "react-router-dom";
import { authService } from "../services";
import { brandingOf } from "../config/branding";
import { useI18n } from "../i18n";
import BrandMark from "../components/BrandMark";
import Icon from "../components/ui/Icon";

const HIGHLIGHTS = [
  { th: "รวมลูกค้า แชท ออเดอร์ และการเงินไว้ในระบบเดียว", en: "Customers, chat, orders and finance in one place" },
  { th: "เปิด-ปิดโมดูลตามประเภทธุรกิจ รองรับ 18 โมเดล", en: "Toggle modules per business type, 18 models supported" },
  { th: "รับชำระเงินด้วย QR PromptPay พร้อมตรวจสลิปอัตโนมัติ", en: "Accept QR PromptPay with automatic slip verification" },
  { th: "ใช้ได้ทั้งเจ้าของธุรกิจ พนักงาน และลูกค้าปลายทาง", en: "Built for owners, staff and end customers" },
];

export default function AuthLayout() {
  const { t, tx } = useI18n();
  const location = useLocation();
  const [search] = useSearchParams();
  const [shop, setShop] = useState(null);

  // เข้าผ่านลิงก์สมัครของร้าน -> โหลดข้อมูลร้านมาแสดงแบรนด์ (ถ้าร้านมีสิทธิ์ White-label) · โหลดไม่ได้ = ใช้แบรนด์ปกติเงียบ ๆ
  const shopCode = (matchPath("/auth/register/customer/:shopCode", location.pathname)?.params.shopCode ||
    (matchPath("/auth/register/customer", location.pathname) ? search.get("shop") : "") ||
    "").toUpperCase();

  useEffect(() => {
    let alive = true;
    setShop(null);
    if (shopCode) {
      authService
        .shopByCode(shopCode)
        .then((row) => alive && setShop(row))
        .catch(() => {});
    }
    return () => {
      alive = false;
    };
  }, [shopCode]);

  const brand = brandingOf(shop);

  return (
    <div className="lz-auth" style={brand.cssVars}>
      <header className="lz-auth__top">
        <Link to="/" className="lz-auth__brand">
          <BrandMark brand={brand} size={32} />
          <span>{brand.name}</span>
        </Link>
        {brand.custom ? null : <span className="lz-auth__tag">{t("app.tagline")}</span>}
      </header>

      <main className="lz-auth__main">
        <div className="lz-auth__card">
          <Outlet />
        </div>

        {brand.custom ? (
          <p className="lz-auth__welcome">{tx(`ยินดีต้อนรับสู่ ${brand.name}`, `Welcome to ${brand.name}`)}</p>
        ) : (
          <ul className="lz-auth__points">
            {HIGHLIGHTS.map((item) => (
              <li key={item.th}>
                <Icon name="check" />
                <span>{tx(item.th, item.en)}</span>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
